<!-- <div class="row">
  <div class="col-12" style="margin-top: 100px;">
  </div>
</div> -->
<div class="container mt-3">
  <div class="row">
    <div class="col-12">
      <h5 class="dark mb-3 underline">
        Payment List
      </h5>
      <table class="table table-bordered mt-3">
        <thead>
          <tr>
            <th scope="col">Payment Order ID</th>
            <!-- <th scope="col">User</th> -->
            <th scope="col">Plan</th>
            <th scope="col">Amount</th>
            <th scope="col">Date</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody *ngIf="paymentData.length > 0">
          <ng-container *ngFor="let data of paymentData">
            <tr>
              <td>{{data.payment_order_no}}</td>
              <!-- <td>{{data.userData.name}}</td> -->
              <td>{{data.plan_name}}</td>
              <td>{{shared.getIntValue(data.amount)}}</td>
              <td>{{data.date | date: 'MM-dd-YYYY'}}</td>
              <td>{{data.status == 1 ? 'Success' : (data.status == 2 ? 'Pending' : 'Rejected')}}</td>
            </tr>
          </ng-container>
        </tbody>
        <tbody *ngIf="paymentData.length == 0">
          <tr>
            <td colspan="6" class="text-center">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>